import { AddIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Checkbox,
    Collapse, Flex, Icon,
    Image,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio, RadioGroup,
    Select,
    Switch,
    Table, Tbody,
    Td,
    Text, Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';
import { useFormik } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { FaExchangeAlt, FaEye } from 'react-icons/fa';
import { FiChevronUp } from 'react-icons/fi';
import { MdClose, MdEdit, MdOutlineEdit } from 'react-icons/md';
import PhoneInput from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import { useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { removeEmptyValues } from 'utils/functions';
import imagePlacementConfig from 'utils/imagePlacementConfig.json';
import videoPlacementConfig from 'utils/videoPlacementConfig.json';
import * as Yup from 'yup';
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';
import UrlParametersUpdate from '../UrlParametersUpdate';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';
import AdPreviewSize from '../AdPreviewSize';

const schema = Yup.object().shape({
    asset_feed_spec: Yup.object().shape({
      destinationType: Yup.string(),
      call_to_action_types: Yup.string().required('Type is required'),
      website_url: Yup.string().when('destinationType', {
        is: (value) => !['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(value),
        then: () => Yup.string().required('Link is required'),
        otherwise: () => Yup.string().notRequired(),
      }),
      phoneNumber: Yup.string().when('call_to_action_types', {
        is: 'CALL_NOW',
        then: () =>
          Yup.string()
            .transform((value) => {
              if (typeof value === 'string') {
                return value.replace(/^tel:\+?/, ''); // Removes "tel:" and "+" if present
              }
              return value;
            })
            .matches(/^[0-9]{12,15}$/, 'Phone number must be between 10 and 15 digits')
            .required('Phone number is required'),
        otherwise: () => Yup.string().notRequired(),
      }),
    }),
  });
  

function SizeMediaUpdateForm({ adData, destinationType, objective, creative, creatives, adAccount, onDelete, onChangeImage, onClick }) {

    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const hoverBorderColor = useColorModeValue('gray.300', 'gray.700');
    const borderColor = useColorModeValue('gray.300', 'inherit');
    const boxBorder = useColorModeValue("gray.300", "purple.800");

    const toast = useToast();
    const { isOpen: isEditMediaOpen, onOpen: OnEditMediaOpen, onClose: OnEditMediaClose } = useDisclosure();
    const { isOpen: isReplaceModalOpen, onOpen: OnReplaceModalOpen, onClose: OnReplaceModalClose } = useDisclosure();
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const { isOpen: isAdPreviewModalOpen, onOpen: onAdPreviewModalOpen, onClose: onAdPreviewModalClose } = useDisclosure();
    const [isCollapsed, setisCollapsed] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const [selectedMediaUrls, setselectedMediaUrls] = useState([]);
    const [activePlacement, setActivePlacement] = useState(null);

    const [updateAdspressocreativeAds, { isLoading: isAdspressoAdsetUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});
    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adAccount?.adsAccountId}, {skip: !adAccount?.adsAccountId});

    const formattedPageIds = useMemo(() => {
        if (!adData?.adsAccounts?.length || !adAccount?.adsAccountId) return [];

        const matchedAccount = adData.adsAccounts.find(
            acc => acc.adsAccountId === adAccount.adsAccountId
        );

        return matchedAccount?.page_id ? [matchedAccount.page_id] : [];
    }, [adData, adAccount]);

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || destinationType !== 'ON_AD' }
    );

    const singleMediaFormik = useFormik({
        enableReinitialize: false,
        initialValues: {
            fileName: '',
            url: '',
            enroll_status: '',
            pac_relaxation_enroll_status: 'OPT_IN',  
            app_id: '',
            caption: '',
            page_welcome_message: '',
            asset_feed_spec: {
                destinationType: destinationType,
                ad_formats: '',
                media: [],
                call_to_action_types: '',
                descriptions: '',
                deeplink_url: '',
                website_url: '',
                phoneNumber: '',
                message: '',
                name: '',
                app_product_page_id: '',
            },
        },
        validationSchema: schema,
        onSubmit: (values, { resetForm }) => {

            // Step 1: Create a hash -> { mediaType, placement } map
            const hashMap = {};
            selectedMediaUrls?.forEach(item => {
                hashMap[item.hash] = {
                    mediaType: item.mediaType,
                    placement: item.placement
                };
            });

            // Step 2: Deduplicate mediaData based on hash
            const seenHashes = new Set();
            const hashDuplicates = new Map();

            // First pass: gather duplicates by hash
            selectedMediaUrls?.forEach(item => {
                if (seenHashes.has(item.hash)) {
                    if (!hashDuplicates.has(item.hash)) {
                        hashDuplicates.set(item.hash, []);
                    }
                    hashDuplicates.get(item.hash).push(item.placement);
                } else {
                    seenHashes.add(item.hash);
                }
            });

            // Reset seenHashes to reuse it
            seenHashes.clear();

            // Second pass: build mediaData with tags
            const mediaData = selectedMediaUrls?.filter(item => {
                if (seenHashes.has(item.hash)) return false;
                seenHashes.add(item.hash);
                return true;
            })
                .map(item => {
                    const duplicatePlacements = hashDuplicates.get(item.hash);
                    const tag = duplicatePlacements?.length
                        ? { duplicatePlacements }
                        : undefined;

                    return {
                        [item.mediaType === 'image' ? 'hash' : 'video_id']: item.hash,
                        thumbnail_url: item.url,
                        [item.mediaType === 'image' ? 'creative_hash' : 'hash']: item.mediaHash,
                        mediaType: item.mediaType,
                        adlabels: [{ name: item.placement }],
                        ...(tag && { tag })
                    };
                });

            // Remove 'tag' before assigning
            const cleanedMediaData = mediaData?.map(({ tag, mediaType, ...rest }) => rest);

            // Step 3: Build asset_customization_rules using hashMap
            const asset_customization_rules = [];

            mediaData?.forEach(media => {
                const meta = hashMap[media.mediaType === 'image' ? media.hash : media.video_id];
                if (!meta) return; // safety check

                const { mediaType } = meta;
                const isDuplicate = media.tag?.duplicatePlacements?.length > 0;
                (media?.adlabels || []).forEach(label => {
                    const placement = label.name;
                    if (!placement) return;

                    asset_customization_rules?.push({
                        [mediaType === 'image' ? 'image_label' : 'video_label']: { name: placement },
                        customization_spec: isDuplicate
                            ? {}
                            : (mediaType === 'image' ? imagePlacementConfig : videoPlacementConfig)[placement] || {}
                    });
                });
            });


            const titles = values.asset_feed_spec.name
                ? [{ text: values.asset_feed_spec.name }]
                : undefined;

            const bodies = values.asset_feed_spec.message
                ? [{ text: values.asset_feed_spec.message }]
                : undefined;

            const descriptions = values.asset_feed_spec.descriptions
                ? [{ text: values.asset_feed_spec.descriptions }]
                : undefined;

            const call_to_action_types = [values.asset_feed_spec.call_to_action_types];

            const call_to_actions = [
                ...(destinationType === 'PHONE_CALL' ? [{
                  type: values.asset_feed_spec.call_to_action_types,
                  value: {
                    link: `tel:+${values.asset_feed_spec.phoneNumber?.replace(/^(\+)?/, '')}`
                  }
                }] : []),
              
                ...(destinationType === 'ON_AD' ? [{
                  type: values.asset_feed_spec.call_to_action_types,
                  value: {
                    lead_gen_form_id: values.asset_feed_spec.website_url
                  }
                }] : [])
              ];
              
            const link_urls = [
                {
                    website_url: destinationType === 'PHONE_CALL' ? `https://facebook.com/${formattedPageIds[0]}/`  : destinationType === 'ON_AD' ? "http://fb.me/" : values.asset_feed_spec.website_url,
                    deeplink_url: values.asset_feed_spec.deeplink_url,
                    ...(!['CALL_NOW','LIKE_PAGE'].includes(values.asset_feed_spec.call_to_action_types) && {display_url: values?.caption})
                }
            ];
            const app_product_page_id = values.asset_feed_spec.app_product_page_id;

            let creativePayload = {};

            creativePayload = values?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ?
                {
                    asset_feed_spec: {
                        ad_formats: [
                            "SINGLE_VIDEO"
                        ],
                        videos: cleanedMediaData,
                        asset_customization_rules: asset_customization_rules,
                        call_to_action_types,
                        call_to_actions,
                        link_urls,
                        app_product_page_id,
                        optimization_type: "PLACEMENT",
                        ...(titles && { titles }),
                        ...(bodies && { bodies }),
                        ...(descriptions && {descriptions}),
                    },
                } : {
                    asset_feed_spec: {
                        ad_formats: [
                            "SINGLE_IMAGE"
                        ],
                        images: cleanedMediaData,
                        asset_customization_rules: asset_customization_rules,
                        call_to_action_types,
                        call_to_actions,
                        link_urls,
                        app_product_page_id,
                        optimization_type: "PLACEMENT",
                        ...(titles && { titles }),
                        ...(bodies && { bodies }),
                        ...(descriptions && {descriptions}),
                    },
                }

            const initialPayload = {
                ...creativePayload,
                contextual_multi_ads: {
                    enroll_status: values.enroll_status,
                },
                ...(
                    ["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) &&
                    values.asset_feed_spec.call_to_action_types !== 'LIKE_PAGE' &&
                    !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType)
                      ? {
                          degrees_of_freedom_spec: {
                            creative_features_spec: {
                              pac_relaxation: {
                                enroll_status: values.pac_relaxation_enroll_status,
                              }
                            }
                          }
                        }
                      : {}
                ),                  
                ...((['WHATSAPP'].includes(destinationType)) && { page_welcome_message: values?.page_welcome_message }),
                ...(values?.url_tags?.trim() && { url_tags: values?.url_tags }),
                ...((objective === "OUTCOME_AWARENESS" || destinationType === 'ON_VIDEO') && {
                    template_url_spec: { config: { app_id: values?.app_id } },
                }),
                fileName: values.fileName || '',
            };
            // console.log({ payload });
            const filteredPayload = removeEmptyValues(initialPayload);

            try {
                updateAdspressocreativeAds({ adcreativeId: creative?._id, payload: filteredPayload }).unwrap()
                    .then(response => {
                        toast({
                            position: "top-right",
                            title: "Ad creative updated",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                    })
                    .catch(error => {
                        const errorMessage = error?.data?.message || "An unexpected error occurred";
                        const formattedMessage = errorMessage.replace(/['"]/g, '');

                        toast({
                            position: "top-right",
                            title: "Error updating Ad creative",
                            description: formattedMessage,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                    });
            } catch (error) {
                console.log(error);

            } finally {
                setisCollapsed(false);
                resetForm();
            }
        }
    });

    useEffect(() => {
        if (creative) {
            singleMediaFormik.setValues({
                fileName: creative.fileName || '',
                url: creative.url || '',
                enroll_status: creative?.contextual_multi_ads?.enroll_status || '',
                url_tags: creative?.url_tags || '',
                pac_relaxation_enroll_status: creative.degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN', 
                page_welcome_message: creative.page_welcome_message,
                caption: creative?.caption || '',
                app_id: creative?.template_url_spec?.config?.app_id || '',    
                asset_feed_spec: {
                    ad_formats: creative.asset_feed_spec?.ad_formats?.[0] || '',
                    media: creative.asset_feed_spec?.ad_formats?.[0] === 'SINGLE_VIDEO'
                        ? creative.asset_feed_spec?.videos || []
                        : creative.asset_feed_spec?.images || [],
                    call_to_action_types: creative.asset_feed_spec?.call_to_action_types?.[0] || '',
                    descriptions: creative.asset_feed_spec?.descriptions && creative.asset_feed_spec?.descriptions[0]?.text || '',
                    deeplink_url: creative.asset_feed_spec?.link_urls && creative.asset_feed_spec?.link_urls[0]?.deeplink_url || '',
                    website_url: creative.asset_feed_spec?.link_urls && creative.asset_feed_spec?.link_urls[0]?.website_url || '',
                    phoneNumber:
                        creative.asset_feed_spec?.call_to_actions &&
                        creative.asset_feed_spec.call_to_actions[0]?.value?.link?.includes('tel:+')
                        ? creative.asset_feed_spec.call_to_actions[0].value.link.replace('tel:+', '')
                        : '',
                    message: creative.asset_feed_spec?.bodies && creative.asset_feed_spec?.bodies[0]?.text || '',
                    name: creative.asset_feed_spec?.titles && creative.asset_feed_spec?.titles[0]?.text || '',
                    app_product_page_id: creative.asset_feed_spec?.app_product_page_id || '',
                },
            });
        }
    }, [creative]);

    useEffect(() => {
        const assetFeed = creative?.asset_feed_spec;
        if (!assetFeed) return;

        const isVideo = assetFeed?.ad_formats?.[0] === 'SINGLE_VIDEO';
        const media = isVideo ? assetFeed.videos || [] : assetFeed.images || [];
        const customizationRules = assetFeed.asset_customization_rules || [];

        // Step 1: Build a map of media data by label
        const mediaMap = {};
        media.forEach((file) => {
            const label = file?.adlabels?.[0]?.name;
            if (label) {
                mediaMap[label] = {
                    placement: label,
                    url: file?.thumbnail_url,
                    mediaType: isVideo ? 'video' : 'image',
                    hash: isVideo ? file?.video_id : file?.hash,
                };
            }
        });

        // Step 2: Find fallback label from customization_rules with empty customization_spec
        const fallbackLabel = customizationRules.find(rule => {
            const spec = rule?.customization_spec;

            // Case 1: customization_spec is missing
            if (!spec) return true;

            const keys = Object.keys(spec).sort();

            // Case 2: customization_spec is empty
            if (keys.length === 0) return true;

            // Case 3: customization_spec has only age_min and age_max
            return keys.length === 2 && keys.includes('age_min') && keys.includes('age_max');
        })?.[isVideo ? 'video_label' : 'image_label']?.name;

        const fallbackMedia = mediaMap[fallbackLabel];

        // Step 3: Ensure all 3 placements
        const requiredPlacements = ['square', 'vertical', 'horizontal'];
        const finalMedia = requiredPlacements.map((label) => {
            if (mediaMap[label]) {
                return mediaMap[label];
            } else if (fallbackMedia) {
                return {
                    ...fallbackMedia,
                    placement: label,
                };
            } else {
                return null;
            }
        }).filter(Boolean); // Remove nulls

        setselectedMediaUrls(finalMedia);
    }, [creative]);

    const handleUrlChange = (constructedUrl) => {
        singleMediaFormik.setFieldValue('link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        singleMediaFormik.setFieldValue('url_tags', constructedUrl);
    };

    const handleReplaceImage = (placement, type) => {
        setActivePlacement(placement);
        OnReplaceModalOpen();
        singleMediaFormik.setFieldValue('asset_feed_spec?.ad_formats', type);
    };

    const handleImageSelectedFromReplaceDrive = (file) => {
        if (file && file.length > 0) {

            const newImageUrl = file[0];

            setselectedMediaUrls((prev) =>
                prev.map((item) =>
                    item.placement === activePlacement
                        ? {
                            ...item,
                            url: newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,
                            hash: newImageUrl?.creativeId,
                            mediaHash: newImageUrl?.hash,
                            source: newImageUrl?.source,
                        }
                        : item
                )
            );
        }
        setActivePlacement(null);
        OnReplaceModalClose();
    };

    const handleMediaSubmit = () => {
        singleMediaFormik.handleSubmit();
        OnEditMediaClose();
    }

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === formattedPageIds[0]);

    return (
        <>
            <Modal
                isOpen={isAdPreviewModalOpen}
                onClose={onAdPreviewModalClose}
                size="3xl"
                scrollBehavior={"inside"}
            >
                <ModalOverlay />
                <ModalContent minH={'60vh'}>
                    <ModalHeader>Ad preview</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {creative && adData ? (() => {
                            const isSizeAd = creative?.asset_feed_spec?.ad_formats && !creative?.product_set_id;

                            if (isSizeAd) {
                                return (
                                    <AdPreviewSize
                                        file={creative}
                                        adData={adData}
                                        creatives={creatives}
                                    />
                                );
                            }

                            return <Text>No preview available</Text>;
                        })() : null}
                    </ModalBody>
                    <ModalFooter justifyContent={'flex-start'} css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }} py={2}>
                        <Text fontSize={'14px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={singleMediaFormik.values.page_welcome_message}
                onSave={(updatedData) => {
                    singleMediaFormik.setFieldValue('page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />
            
            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={singleMediaFormik?.values} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={singleMediaFormik?.values} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isEditMediaOpen} onClose={OnEditMediaClose} scrollBehavior={"inside"} size={"5xl"} isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Select media for placements</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <>
                            <ReplaceDriveModal
                                isDriveModalOpen={isReplaceModalOpen}
                                selectedAdAccounts={[{
                                    id: adAccount?.id,
                                    adsAccountId: adAccount?.adsAccountId,
                                    adsAccountName: adAccount?.adsAccountName,
                                }]}
                                onClose={() => {
                                    OnReplaceModalClose();
                                }}
                                onSubmit={handleImageSelectedFromReplaceDrive}
                                uploadPurpose="update"
                                mediaType={singleMediaFormik?.values?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ? 'video' : 'image'}
                            />
                            <Flex gap={2} justifyContent="center">
                                {selectedMediaUrls
                                    ?.sort((a, b) => {
                                    const order = ['square', 'vertical', 'horizontal'];
                                    return order.indexOf(a.placement) - order.indexOf(b.placement);
                                    })
                                    .map(({ placement, url, source, mediaType }) => {
                                        // Filter logic
                                        const shouldSkip =
                                            (destinationType === 'APP' &&
                                            ['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(objective) || destinationType === 'WHATSAPP') &&
                                            placement !== 'square' &&
                                            placement !== 'vertical';

                                        if (shouldSkip) return null;

                                    return (
                                        <Box
                                        key={placement}
                                        border="1px solid"
                                        borderColor="gray.100"
                                        borderRadius="md"
                                        p={2}
                                        width="240px"
                                        height={
                                            placement === 'square'
                                            ? '300px'
                                            : placement === 'vertical'
                                            ? '530px'
                                            : '230px'
                                        }
                                        display="flex"
                                        flexDirection="column"
                                        gap={2}
                                        >
                                        <Text fontWeight="bold" textTransform="capitalize">
                                            {placement}
                                        </Text>

                                        {source ? (
                                            <Box
                                            width="220px"
                                            height={
                                                placement === 'square'
                                                ? '200px'
                                                : placement === 'vertical'
                                                ? '440px'
                                                : '120px'
                                            }
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            bg="gray.200"
                                            borderRadius="md"
                                            >
                                            <Box
                                                as="video"
                                                controls
                                                src={source}
                                                maxWidth="100%"
                                                maxHeight="100%"
                                                style={{ objectFit: 'contain', objectPosition: 'center' }}
                                            />
                                            </Box>
                                        ) : (
                                            <Box
                                            width="220px"
                                            height={
                                                placement === 'square'
                                                ? '200px'
                                                : placement === 'vertical'
                                                ? '430px'
                                                : '120px'
                                            }
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            bg="gray.200"
                                            borderRadius="md"
                                            >
                                            <Image
                                                src={url}
                                                alt={placement}
                                                maxWidth="100%"
                                                maxHeight="100%"
                                                objectFit="contain"
                                                objectPosition="center"
                                            />
                                            </Box>
                                        )}

                                        <Flex>
                                            <Button
                                            size="sm"
                                            variant={'solid'}
                                            colorScheme={'gray'}
                                            mt={2}
                                            leftIcon={<FaExchangeAlt />}
                                            onClick={() => handleReplaceImage(placement, mediaType)}
                                            >
                                            Replace
                                            </Button>
                                        </Flex>
                                        </Box>
                                    );
                                    })}
                            </Flex>
                        </>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button 
                            colorScheme="gray"
                            variant="solid"
                            size={'sm'} 
                            onClick={OnEditMediaClose}
                        >
                            Cancel
                        </Button>
                        <Button colorScheme="brand" size={'sm'} onClick={handleMediaSubmit} isLoading={isAdspressoAdsetUpdating}>
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Box p={1} borderWidth={1} borderRadius="md" borderColor={boxBorder}>
                <Flex alignItems="center" gap={2} justify="space-between">
                    <Flex alignItems="center" gap={2}>
                        {selectedMediaUrls && selectedMediaUrls[0]?.url ? (
                            <Image
                                src={(selectedMediaUrls[0]?.url)}
                                alt={"adcreative-img"}
                                objectFit="cover"
                                width="50px"
                                height="36px"
                                borderRadius="3px"
                            />
                        ) : (
                            <AddIcon boxSize={5} ml={2} mr={2} />
                        )}
                        <Flex direction={'column'}>
                            <Text fontSize="10px" noOfLines={1}>
                                {singleMediaFormik.values?.asset_feed_spec?.name}
                            </Text>
                        </Flex>

                    </Flex>
                    <Flex alignItems="center" gap={'5px'}>
                        <Tooltip label="Edit copy" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={isCollapsed ? FiChevronUp : MdEdit}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={() => userInfo?.role === 'client' && setisCollapsed(!isCollapsed)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Ad preview" fontSize="xs">
                            <Box>
                                 <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={FaEye}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={onAdPreviewModalOpen}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Remove creative" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.400' }}
                                    as={MdClose}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    boxSize={5}
                                    onClick={() => userInfo?.role === 'client' && onDelete(creative?._id)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'red.500'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                    </Flex>
                </Flex>
                <Collapse in={isCollapsed}>
                    <Box p={'10px'}>
                        <Flex direction={'column'}>
                            <Flex position="relative" alignItems="center" gap={4} p={2} borderRadius="md" bg={backgroundColor}>
                                {selectedMediaUrls && selectedMediaUrls[0]?.url ? (
                                    <Image
                                        src={(selectedMediaUrls[0]?.url)}
                                        alt={"adcreative-img"}
                                        objectFit="cover"
                                        width="80px"
                                        height="80px"
                                        borderRadius="3px"
                                    />
                                ) : (
                                    <Box p={4}>
                                        <Button
                                            bg={'gray.50'}
                                            borderWidth={1}
                                            size="sm"
                                            onClick={() => {
                                                onChangeImage(creative, adAccount);
                                            }}
                                        >
                                            {selectedMediaUrls[0]?.mediaType === 'image' ? 'Select Image' : 'Select Video'}
                                        </Button>
                                    </Box>
                                )}

                                {/* {url ?
                                <Box position="absolute" top={2} right={2} cursor="pointer" zIndex={1}>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>
                                                    Remove Image
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <CloseIcon
                                            mb={2}
                                            color="red.500"
                                            boxSize={3}
                                            pointerEvents="all"
                                            onClick={() => {
                                                onRemoveImage(_id);
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                                : null
                            } */}

                                {selectedMediaUrls && selectedMediaUrls[0]?.url ?
                                    <Flex>
                                        <Tooltip label="Edit Media" fontSize="xs">
                                            <Flex
                                                p={2}
                                                border="1px solid"
                                                borderColor={borderColor}
                                                borderRadius="md"
                                                alignItems={'center'}
                                                _hover={{ bg: hoverBorderColor }}
                                            >
                                                <Icon
                                                    as={MdOutlineEdit}
                                                    cursor="pointer"
                                                    fontSize="18px"
                                                    onClick={OnEditMediaOpen}
                                                />
                                            </Flex>
                                        </Tooltip>
                                    </Flex>
                                    : null
                                }
                            </Flex>

                            {["OUTCOME_AWARENESS","OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) && singleMediaFormik?.values?.type !== "LIKE_PAGE" && !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(destinationType) ? 
                                    <Flex direction={'column'} gap={2} mb={4}>
                                        <Flex alignItems="center">
                                            <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                                        <Text fontWeight={'bold'}>Flexible media</Text>
                                                        <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                                        <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                                    </Flex>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Flex alignItems={'center'} gap={2}>
                                            <Switch size={'sm'} colorScheme='brand' isChecked={singleMediaFormik.values.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => singleMediaFormik.setFieldValue('pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                            <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                                        </Flex>
                                    </Flex>
                            : null}

                            {/* Multi-advertiser ads Section */}
                            <Flex direction="column" mb={4} borderRadius="md" gap={2}>
                                <Checkbox
                                    onChange={(e) => {
                                        singleMediaFormik.setFieldValue("enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                    }}
                                    colorScheme="brand"
                                    isChecked={singleMediaFormik.values.enroll_status === 'OPT_IN'}
                                >
                                    <Flex align={'center'}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                </Checkbox>
                            </Flex>

                            <Box mb={'0px'} mt={'10px'}>
                                {Boolean(adData?.useFileName) ? (
                                    <Flex mb={4} direction="column">
                                        <Flex alignItems="center" mb={2} gap={2}>
                                            <Text fontSize={'14px'} fontWeight="bold">Ad name</Text>
                                        </Flex>
                                        <Input
                                            placeholder="Ad name"
                                            name="fileName"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={singleMediaFormik.values.fileName}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                    </Flex>
                                ) : null}

                                <Flex mb={4} direction="column" gap={2}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontSize={'14px'} fontWeight="bold">Primary text</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>
                                                        The primary text for your ad appears in most placements, though the position
                                                        varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                                                        characters or less.
                                                    </Text>
                                                </Box>
                                            }
                                            fontSize="md">
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        placeholder="Tell people what your ad is about..."
                                        name="asset_feed_spec.message"
                                        size={'sm'}
                                        borderRadius="md"
                                        value={singleMediaFormik.values.asset_feed_spec.message}
                                        onChange={singleMediaFormik.handleChange}
                                    />
                                </Flex>

                                <Flex mb={'20px'} direction="column" gap={2}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontSize={'14px'} fontWeight="bold">Headline</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>
                                                        Add up to five brief headlines to let people know what your ad is about. Each
                                                        headline can have a maximum of 255 characters. Headlines won't appear in all
                                                        placements.
                                                    </Text>
                                                </Box>
                                            }
                                            fontSize="md">
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        placeholder="Write a short headline"
                                        name="asset_feed_spec.name"
                                        size={'sm'}
                                        borderRadius="md"
                                        value={singleMediaFormik.values.asset_feed_spec.name}
                                        onChange={singleMediaFormik.handleChange}
                                    />
                                </Flex>

                                {['APP', 'ON_PAGE'].includes(destinationType) ? null :
                                    <Box direction="column" mb={'15px'}>
                                        <Flex alignItems="center" mb={'8px'} gap={2}>
                                            <Text fontSize={'14px'} fontWeight="bold">Description</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>
                                                            Add up to five link descriptions to emphasize why people should visit your
                                                            website. This won't appear in all placements.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Textarea
                                            placeholder="Include additional details"
                                            name="asset_feed_spec.descriptions"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={singleMediaFormik.values.asset_feed_spec.descriptions}
                                            onChange={singleMediaFormik.handleChange}
                                            rows={2}
                                        />
                                    </Box>
                                }

                                {singleMediaFormik?.values?.asset_feed_spec?.call_to_action_types === "LIKE_PAGE" ? null :
                                    <Box direction="column" mb={'20px'}>
                                        <Flex alignItems="center" mb={2} gap={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Call to action</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Select
                                            name="asset_feed_spec.call_to_action_types"
                                            borderRadius={'md'}
                                            value={singleMediaFormik.values.asset_feed_spec.call_to_action_types}
                                            onChange={singleMediaFormik.handleChange}
                                            size={'sm'}
                                            isDisabled={singleMediaFormik.values.asset_feed_spec.call_to_action_types === 'CALL_NOW' || (destinationType === 'WHATSAPP' && objective === 'OUTCOME_LEADS')}
                                        >
                                            {singleMediaFormik.values.asset_feed_spec.call_to_action_types === 'CALL_NOW' ? (
                                                <option value={'CALL_NOW'}>
                                                    Call Now
                                                </option>
                                            ) : destinationType === 'ON_AD' ? (
                                                <>
                                                    {call_to_action_options_instantForms?.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                             ) : destinationType === 'APP' && objective === 'OUTCOME_APP_PROMOTION' ? (
                                                <>
                                                    {call_to_action_options_app_promptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : destinationType === 'APP' && ['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(objective) ? (
                                                <>
                                                    {call_to_action_options_for_app_leads_and_sales.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            ) :  destinationType === 'WHATSAPP' ? (
                                                <>
                                                    {call_to_action_options_whatsapp.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : objective === 'OUTCOME_AWARENESS' || (["OUTCOME_ENGAGEMENT","OUTCOME_TRAFFIC"].includes(objective) && destinationType === 'WEBSITE') || destinationType === 'ON_VIDEO'  ? (
                                                <>
                                                    <option value={'SHOP_NOW'}>
                                                        {'Shop now'}
                                                    </option>
                                                    <option value={'SIGN_UP'}>
                                                        {'Sign up'}
                                                    </option>
                                                </>
                                            ) :
                                                <>
                                                    {call_to_action_options?.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </>
                                            }
                                        </Select>
                                    </Box>
                                }

                                {destinationType === 'ON_AD' ? (
                                    <>
                                        <Flex alignItems="center" gap={2} mt={2}>
                                            <Text fontWeight="bold">Instant form</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>

                                        {/* Table Layout */}
                                        {filteredInstantForms?.length > 0 ? (
                                            <RadioGroup onChange={(value) => singleMediaFormik.setFieldValue('asset_feed_spec.website_url', value)} value={singleMediaFormik.values.asset_feed_spec.website_url} colorScheme="brand">
                                                <Table variant="simple">
                                                    <Thead>
                                                        <Tr>
                                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                                                            <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                        {filteredInstantForms?.map((form) => (
                                                            <Tr key={form?.id} _hover={{ backgroundColor: '#F9F9F9' }} >
                                                                <Td>
                                                                    <Flex alignItems="center" gap={2}>
                                                                        <Radio value={form?.id} />
                                                                        <Text color={form.status === 'DRAFT' ? "gray.500" : "black"} fontSize={'12px'}>
                                                                            {form?.name}
                                                                        </Text>
                                                                    </Flex>
                                                                </Td>
                                                                <Td>
                                                                    <Text fontSize={'12px'}>
                                                                        {new Date(form?.created_time).getFullYear()}-
                                                                        {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                        {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                                    </Text>
                                                                </Td>
                                                            </Tr>
                                                        ))}
                                                    </Tbody>
                                                </Table>
                                            </RadioGroup>
                                        ) : (
                                            <Text fontSize="14px" color="gray.500">No form data available</Text>
                                        )}
                                    </>
                                ) : null}

                                {['WEBSITE', 'ON_VIDEO'].includes(destinationType) || objective === 'OUTCOME_AWARENESS' ? (
                                    <>
                                        <Flex mb={4} direction="column">
                                            <Flex alignItems="center" gap={2} mb={'10px'}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Website URL</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                            <Text>Enter the URL for the webpage you want people to visit</Text>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Flex direction={'column'} gap={1}>
                                                <Input
                                                    type="url"
                                                    name="asset_feed_spec.website_url"
                                                    borderRadius={'md'}
                                                    placeholder="Enter URL"
                                                    value={singleMediaFormik.values.asset_feed_spec.website_url}
                                                    onChange={singleMediaFormik.handleChange}
                                                    size={'sm'}
                                                />
                                                <Flex mt={2}>
                                                    <Button onClick={() => {
                                                        setUrlModalOpen(true)
                                                    }}
                                                        variant="link"
                                                        color='brand'>
                                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                                    </Button>
                                                </Flex>
                                                {singleMediaFormik.touched.asset_feed_spec?.website_url &&
                                                    singleMediaFormik.errors.asset_feed_spec?.website_url && (
                                                    <Text color="red.500" fontSize="12px">
                                                        {singleMediaFormik.errors.asset_feed_spec.website_url}
                                                    </Text>
                                                )}
                                            </Flex>
                                        </Flex>
                                    </>
                                ) : null}

                                {destinationType === 'APP' && objective === 'OUTCOME_APP_PROMOTION'  ? (
                                    <>
                                        <Flex mb={4} direction="column" gap={2}>
                                            <Flex alignItems="center" gap={2}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                            <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                            <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                            <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                            <Box>
                                                                <Text>* Android app link</Text>
                                                                <Text>* Custom URL scheme</Text>
                                                                <Text>* Facebook app link</Text>
                                                            </Box>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Input
                                                name="asset_feed_spec.deeplink_url"
                                                borderRadius={'md'}
                                                placeholder="Enter URL"
                                                value={singleMediaFormik.values.asset_feed_spec.deeplink_url}
                                                onChange={singleMediaFormik.handleChange}
                                                size={'sm'}
                                            />
                                        </Flex>
                                        <Flex mb={4} direction="column" gap={2}>
                                            <Flex alignItems="center" gap={2}>
                                                <Text fontWeight="bold" fontSize="14px">Custom store listing</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                            <Text fontWeight="bold">Using a custom store listing</Text><br />
                                                            <Text mb={2}>A custom store listing ID sends people to a landing page you've customized...</Text>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Input
                                                placeholder="Enter custom store listing ID"
                                                name="asset_feed_spec.app_product_page_id"
                                                size={'sm'}
                                                borderRadius="md"
                                                value={singleMediaFormik.values.asset_feed_spec.app_product_page_id}
                                                onChange={singleMediaFormik.handleChange}
                                            />
                                        </Flex>
                                    </>
                                ) : null}

                                {destinationType === 'APP' && ['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(objective) ? (
                                    <>
                                        <Flex mb={4} direction="column" gap={2}>
                                            <Flex alignItems="center" gap={2}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                                <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                        <Box fontSize="12px" p="5px">
                                                           <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                        </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Input
                                                type="url"
                                                name="asset_feed_spec.website_url"
                                                borderRadius={'md'}
                                                placeholder="Enter the deep link URL"
                                                value={singleMediaFormik.values.asset_feed_spec.website_url}
                                                onChange={singleMediaFormik.handleChange}
                                                size={'sm'}
                                            />
                                        </Flex>
                                    </>
                                ) : null}

                                {singleMediaFormik?.values?.asset_feed_spec?.call_to_action_types === 'CALL_NOW' ? (
                                    <>
                                        <Box mb={4}>
                                            <Text fontWeight="bold" fontSize={'14px'} mb={'10px'}>Call now</Text>
                                            <PhoneInput
                                                country={'in'}
                                                value={singleMediaFormik?.values?.asset_feed_spec.phoneNumber}
                                                onChange={(value) => {
                                                    singleMediaFormik.setFieldValue('asset_feed_spec.phoneNumber', value)
                                                }}
                                                inputProps={{
                                                    name: 'phoneNumber',
                                                    required: true,
                                                    autoFocus: true,
                                                }}
                                                enableSearch={true}
                                                searchPlaceholder="Search"
                                            />

                                            {singleMediaFormik.touched?.asset_feed_spec?.phoneNumber && singleMediaFormik.errors?.asset_feed_spec?.phoneNumber ? (
                                                <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors?.asset_feed_spec?.phoneNumber}</Text>
                                            ) : null}
                                        </Box>
                                    </>
                                ) : null}

{['WHATSAPP'].includes(destinationType) ? (
                                    <>
                                        <Flex mb={2}>
                                            <Text fontWeight={'bold'} fontSize={'sm'}>Message template</Text>
                                        </Flex>
                                    
                                        {(() => {
                                        const welcomeData = singleMediaFormik?.values?.page_welcome_message;

                                        const type = welcomeData?.text_format?.customer_action_type;

                                        const greeting = welcomeData?.text_format?.message?.text || '';
                                        const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                        const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                        return (
                                            <Box mb={2}>
                                                <Box border={'1px solid'} borderColor={'gray.200'} p={2} borderRadius={'md'} bg={backgroundColor}>
                                                    <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                                    {type === 'autofill_message' && (
                                                        <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                                    )}

                                                    {type === 'ice_breakers' && (
                                                        <>
                                                        <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                        {iceBreakers.map((q, i) => (
                                                            <Text key={i} fontSize="14px">
                                                            {i + 1}. {q.title}
                                                            </Text>
                                                        ))}
                                                        </>
                                                    )}
                                                </Box>

                                                <Button
                                                    variant="outline"
                                                    backgroundColor="transparent" 
                                                    size={'sm'}
                                                    leftIcon={<MdOutlineEdit />}
                                                    mt={2}
                                                    onClick={() => {
                                                        onMessageModalOpen();
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            </Box>
                                        );
                                        })()}
                                    </>
                                ) : null}

                                {(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(objective) && !['PHONE_CALL', 'APP', 'WHATSAPP'].includes(destinationType) && singleMediaFormik?.values?.type !== "LIKE_PAGE")  ? 
                                    <Flex direction="column" gap={2} mb={4}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Display link</Text>
                                        <Input
                                            name="caption"
                                            placeholder="Enter the link that you want to show on your ad"
                                            bg="#fff"
                                            size='sm'
                                            borderRadius="md"
                                            value={singleMediaFormik.values.caption}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                    </Flex>
                                :null}

                                {objective === "OUTCOME_AWARENESS" || destinationType === 'ON_VIDEO' ? 
                                    <Flex direction={'column'} gap={1} mb={4}>
                                        <Flex alignItems="center" gap={2} mb={'5px'}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Mobile app</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Select
                                            name={`app_id`}
                                            bg="#fff"
                                            size="sm"
                                            borderRadius="md"
                                            onChange={singleMediaFormik.handleChange}
                                            onBlur={singleMediaFormik.handleBlur}
                                            value={singleMediaFormik?.values?.app_id}
                                        >
                                            <option value="">Choose app</option>
                                            {advertisableApps?.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </Flex>
                                :null}

                                {['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(destinationType) ? null :
                                    <Flex direction="column" gap={1}>
                                        <Flex alignItems={'center'}>
                                            <Text mb={'5px'} fontWeight="bold" fontSize={'14px'}>
                                                URL parameters{" "}
                                                {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                                <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                            </Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="12px" p={'5px'}>
                                                        <Text >
                                                            Add parameters to the end of your website URL to track where your visitors are coming from.
                                                        </Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                            </Tooltip>
                                        </Flex>
                                        <Input
                                            name="url_tags"
                                            placeholder="key1=value1&key2=value2"
                                            bg="#fff"
                                            size='sm'
                                            borderRadius="md"
                                            value={singleMediaFormik.values.url_tags}
                                            onChange={singleMediaFormik.handleChange}
                                        />
                                        <Flex mt={1}>
                                            <Button onClick={() => {
                                                setUrlParamModalOpen(true)
                                            }}
                                                variant="link"
                                                color='brand'>
                                                <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                            </Button>
                                        </Flex>
                                    </Flex>
                                }

                                <Flex justifyContent="flex-start" mt={'20px'}>
                                    <Button
                                        colorScheme="brand"
                                        onClick={() => singleMediaFormik.handleSubmit()}
                                        size={'sm'}
                                        isLoading={isAdspressoAdsetUpdating}
                                    >
                                        Save
                                    </Button>
                                </Flex>
                            </Box>
                        </Flex>
                    </Box>
                </Collapse>
            </Box>
        </>
    )
}

export default SizeMediaUpdateForm